// branches-data.ts
export const branchesData = [
    { id: 1, name: 'Alor Setar' },
    { id: 2, name: 'Batu Pahat' },
    { id: 3, name: 'Ipoh' },
    { id: 4, name: 'Johor Bahru' },
    { id: 5, name: 'Kota Bharu' },
    { id: 6, name: 'Kota Kinabalu' },
    { id: 7, name: 'Kuala Lumpur (Wangsa Maju)' },
    { id: 8, name: 'Kuala Terengganu' },
    { id: 9, name: 'Kuantan' },
    { id: 10, name: 'Kuching' },
    { id: 11, name: 'Melaka' },
    { id: 12, name: 'Miri' },
    { id: 13, name: 'Prai' },
    { id: 14, name: 'Sandakan' },
    { id: 15, name: 'Selangor (HQ)' },
    { id: 16, name: 'Seremban' },
];
